var render = function render(){
  var _domProps;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    staticClass: "border-custom",
    "class": _vm.color,
    attrs: {
      "id": _vm.id + 'xd',
      "min": _vm.min,
      "max": _vm.max,
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.valueGiven,
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, _vm.valueGiven) > -1 : _vm.value
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.valueGiven,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.value = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.value = $$c;
        }
      }, _vm.emitChangeEvent]
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    staticClass: "border-custom",
    "class": _vm.color,
    attrs: {
      "id": _vm.id + 'xd',
      "min": _vm.min,
      "max": _vm.max,
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "type": "radio"
    },
    domProps: {
      "value": _vm.valueGiven,
      "checked": _vm._q(_vm.value, _vm.valueGiven)
    },
    on: {
      "change": [function ($event) {
        _vm.value = _vm.valueGiven;
      }, _vm.emitChangeEvent]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    staticClass: "border-custom",
    "class": _vm.color,
    attrs: {
      "id": _vm.id + 'xd',
      "min": _vm.min,
      "max": _vm.max,
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "type": _vm.type
    },
    domProps: (_domProps = {
      "value": _vm.valueGiven
    }, _domProps["value"] = _vm.value, _domProps),
    on: {
      "change": _vm.emitChangeEvent,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.value = $event.target.value;
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }